import { useState, useMemo } from "react";
import IDataSourceProps from "../../../../../../../../../shared/contracts/IDataSourceProps";

interface IProps {
    defaultItem: IDataSourceProps | null;
    originalList: IDataSourceProps[];
    reservedList: IDataSourceProps[];
}
/**
 * @author Pradeep R <pradeep.rajendran@rldatix.com>
 * @createdOn Dec/01/2024
 */
export default function useWizardDataSource({ defaultItem, originalList, reservedList }: IProps) {
    const [selectedItem, setSelectedItem] = useState<IDataSourceProps | null>(defaultItem);

    // Filter the original list, excluding reserved items
    const baseFilteredList = useMemo(() => {
        const reservedSet = new Set(reservedList.map(item => item.dataSourceCode));
        return originalList.filter(item => !reservedSet.has(item.dataSourceCode));
    }, [originalList, reservedList]);

    // Include selectedItem and sort the list
    const filteredList = useMemo(() => {
        const combinedList = selectedItem ? [...baseFilteredList, selectedItem] : baseFilteredList;
    
        return combinedList.sort((a, b) => {
            const categoryA = (a.dataSourceCategory || '').toLowerCase(); // Fallback to empty string
            const categoryB = (b.dataSourceCategory || '').toLowerCase();
            const codeA = (a.dataSourceName || '').toLowerCase();
            const codeB = (b.dataSourceName || '').toLowerCase();
    
            // First, sort by category
            if (categoryA.localeCompare(categoryB) !== 0) {
                return categoryA.localeCompare(categoryB);
            }
            // Then, sort by code if categories are the same
            return codeA.localeCompare(codeB);
        });
    }, [baseFilteredList, selectedItem]);

    // ---
    return {
        filteredList, // Return the final sorted list
        selectedItem,
        setSelectedItem,
    };
}